export const ELEMENT_DISPLAY_MODES = {
    ICON_VIEW: 'ICON_VIEW',
    DETAIL_VIEW: 'DETAIL_VIEW',
};

export const DEFAULT_ICON_VIEW_WIDTH = 10;
export const DEFAULT_ICON_VIEW_HEIGHT = 14;
